import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FetchWithSpinner from 'components/fetch-with-spinner'
import Layout from 'interview/components/layout'
import { fetchCandidate } from 'interview/actions/candidate'
import { setLanguage } from 'actions'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  params: PropTypes.shape({}).isRequired,
}
class Index extends Component {
  /**
   * On mount change language is in query params and this way we get localized
   * error messages even candidate can't be loaded
   */
  componentDidMount() {
    const { dispatch, location: { query: { lang } } } = this.props
    if (lang) {
      dispatch(setLanguage(lang))
    }
  }

  render() {
    const { params, children } = this.props

    return (
      <FetchWithSpinner action={() => fetchCandidate(params)}>
        <Layout size="small">
          {children}
        </Layout>
      </FetchWithSpinner>
    )
  }
}

Index.propTypes = propTypes

export default connect()(Index)
